import React, { useRef } from 'react';
import FilterPopover from './FilterPopover';
import { FONT } from '../constants';
import { C } from '../styles';
import type { StatusKey } from '../types';

interface Props {
  statusFilter: StatusKey[];
  setStatusFilter: (filters: StatusKey[]) => void;
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  searchExpanded: boolean;
  setSearchExpanded: (b: boolean) => void;
  onExport: () => void;
}

export default function RunPayrollToolbar({
  statusFilter, setStatusFilter,
  searchQuery, setSearchQuery,
  searchExpanded, setSearchExpanded,
  onExport,
}: Props) {
  const searchInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
        <FilterPopover value={statusFilter} onApply={setStatusFilter} />
        {!searchExpanded && !searchQuery ? (
          <div onClick={() => { setSearchExpanded(true); setTimeout(() => searchInputRef.current?.focus(), 0); }} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 12px', border: '1px solid ' + C.line, borderRadius: 999, background: (C as any).page, cursor: 'pointer', fontFamily: FONT }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={C.ink} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <span style={{ fontSize: 12, color: C.ink, fontWeight: 600 }}>Search</span>
          </div>
        ) : (
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 12px', border: '1px solid ' + C.ink, borderRadius: 999, background: '#fff', width: 240, fontFamily: FONT }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={C.ink} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search employees..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onBlur={() => { if (!searchQuery) setSearchExpanded(false); }}
              style={{ border: 'none', outline: 'none', fontSize: 12, color: C.ink, flex: 1, background: 'transparent', fontFamily: FONT }}
            />
          </div>
        )}
        <button onClick={onExport} style={{ padding: '5px 12px', background: '#fff', border: '1.5px solid ' + C.ink, borderRadius: 8, fontSize: 12, color: C.ink, fontWeight: 700, cursor: 'pointer', fontFamily: FONT, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Export
        </button>
      </div>

      <div style={{ background: '#E1F5EE', borderLeft: '3px solid ' + (C as any).brand, borderRadius: '0 8px 8px 0', padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: C.ink }}>
        <span style={{ fontSize: 15 }}>💡</span>
        <span style={{ flex: 1, fontWeight: 500 }}>Click the arrow next to any employee to add overtime, vacation, or sick hours.</span>
      </div>
    </>
  );
}